import { Link, useNavigate } from "react-router-dom";
import { Search, ShoppingBag, User, Heart, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const CATS = ["Feminino", "Masculino", "Infantil", "Acessórios", "Novidades", "Promoções"];
export default function Header() {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const { count, setOpen } = useCart();
  const { user } = useAuth();

  const doSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/buscar?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-neutral-200/80">
      <div className="bg-[#181818] text-white text-xs sm:text-sm text-center py-2 px-4">
        <span className="font-medium">Retirada grátis na loja física • Magé - RJ</span>
        <span className="hidden sm:inline"> • Pix, Cartão e Parcelamento • Atendimento pelo WhatsApp</span>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3 sm:gap-6">
        {/* Mobile menu */}
        <Sheet>
          <SheetTrigger asChild>
            <button data-testid="mobile-menu-btn" className="md:hidden p-2 -ml-2" aria-label="Menu">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-72">
            <div className="mt-6 space-y-1">
              {CATS.map((c) => (
                <Link key={c} to={`/categoria/${encodeURIComponent(c)}`} className="block px-3 py-3 rounded-md hover:bg-neutral-100 font-medium">
                  {c}
                </Link>
              ))}
              <div className="border-t my-3" />
              <Link to="/conta" className="block px-3 py-3 rounded-md hover:bg-neutral-100">Minha conta</Link>
              <Link to="/favoritos" className="block px-3 py-3 rounded-md hover:bg-neutral-100">Favoritos</Link>
              <Link to="/institucional/sobre" className="block px-3 py-3 rounded-md hover:bg-neutral-100">Sobre a Nalin</Link>
              <Link to="/institucional/loja" className="block px-3 py-3 rounded-md hover:bg-neutral-100">Nossa loja</Link>
            </div>
          </SheetContent>
        </Sheet>

        <Link to="/" data-testid="header-logo" className="flex items-center gap-1 shrink-0">
          <div className="flex flex-col leading-none">
            <span className="font-extrabold tracking-tight text-2xl sm:text-3xl text-[#C91F1F]" style={{ fontFamily: "Outfit" }}>
              NALIN
            </span>
            <span className="text-[9px] sm:text-[10px] tracking-[0.25em] text-[#D4A928] font-bold -mt-0.5">
              ATACADO & VAREJO
            </span>
          </div>
        </Link>

        <form onSubmit={doSearch} className="hidden md:flex flex-1 max-w-xl relative">
          <input
            data-testid="header-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar produtos, categorias..."
            className="w-full pl-11 pr-4 py-2.5 rounded-full bg-neutral-100 border border-transparent focus:bg-white focus:border-[#C91F1F] focus:outline-none transition"
          />
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500" />
        </form>

        <nav className="hidden lg:flex items-center gap-5 text-sm font-medium">
          <Link to="/categoria/Feminino" className="hover:text-[#C91F1F]">Feminino</Link>
          <Link to="/categoria/Masculino" className="hover:text-[#C91F1F]">Masculino</Link>
          <Link to="/categoria/Acessórios" className="hover:text-[#C91F1F]">Acessórios</Link>
          <Link to="/categoria/Promoções" className="text-[#C91F1F]">Ofertas</Link>
        </nav>

        <div className="ml-auto flex items-center gap-1 sm:gap-3">
          <Link to="/conta" data-testid="header-account-btn" className="hidden sm:flex p-2 rounded-full hover:bg-neutral-100" aria-label="Minha conta">
            <User className="h-5 w-5" />
          </Link>
          <Link to="/favoritos" data-testid="header-favorites-btn" className="hidden sm:flex p-2 rounded-full hover:bg-neutral-100" aria-label="Favoritos">
            <Heart className="h-5 w-5" />
          </Link>
          <button data-testid="header-cart-btn" onClick={() => setOpen(true)} className="relative p-2 rounded-full hover:bg-neutral-100" aria-label="Carrinho">
            <ShoppingBag className="h-5 w-5" />
            {count > 0 && (
              <span data-testid="header-cart-count" className="absolute -top-0.5 -right-0.5 bg-[#C91F1F] text-white text-[10px] font-bold h-4 w-4 rounded-full flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      <form onSubmit={doSearch} className="md:hidden px-4 pb-3 relative">
        <input
          data-testid="mobile-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar produtos..."
          className="w-full pl-10 pr-4 py-2 rounded-full bg-neutral-100 focus:bg-white focus:outline-none border border-transparent focus:border-[#C91F1F]"
        />
        <Search className="absolute left-7 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-500" />
      </form>
    </header>
  );
}
